export default {
  notifications(state) {
    return state.notifications;
  },
  unreadNotifCount(state) {
    return state.unreadNotifCount;
  },
};
